module.exports = __webpack_public_path__ + "img/intersection.26b11135.svg";